import {Component, Input, OnInit, PLATFORM_ID} from '@angular/core';
import {Title, Meta} from '@angular/platform-browser';
import {Inject} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import 'rxjs/add/operator/pairwise';
import {Router} from '@angular/router';

@Component({
  selector: 'app-page404',
  templateUrl: './page404.component.html',
  styleUrls: ['./page404.component.css']
})
export class Page404Component implements OnInit {

  private noise: any;
  @Input()
  public currentURL: string;

  constructor(private Title: Title,
              private Meta: Meta,
              private router: Router,
              @Inject(PLATFORM_ID) private platformId: Object) {
    this.router.events.pairwise().subscribe(() => {
      this.noise.loop = false;
      this.noise.pause();
    });
  }

  ngOnInit() {
    this.currentURL = this.router.url;
    this.Title.setTitle(`404 → ${this.currentURL}`);
    this.Meta.addTag({name: 'description', content: 'Description goes here'});
    this.playNoise();
  }

  playNoise() {
    if (isPlatformBrowser(this.platformId)) {
      this.noise = new Audio('../assets/sounds/static-noise.mp3');
      this.noise.addEventListener('canplay', () => {
        this.noise.volume = 0.3;
        this.noise.loop = true;
        this.noise.play();
      }, false);
    }
  }

}



// WEBPACK FOOTER //
// /opt/buildhome/repo/src/app/page404/page404.component.ts